export default function UserProfileIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M10.1331 9.05833C10.0498 9.05 9.9498 9.05 9.85814 9.05833C7.8748 8.99166 6.2998 7.36666 6.2998 5.36666C6.2998 3.325 7.9498 1.66666 9.9998 1.66666C12.0415 1.66666 13.6998 3.325 13.6998 5.36666C13.6915 7.36666 12.1165 8.99166 10.1331 9.05833Z'
        stroke='#0D1333'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.9666 12.1333C3.94993 13.4833 3.94993 15.6833 5.9666 17.025C8.25827 18.5583 12.0166 18.5583 14.3083 17.025C16.3249 15.675 16.3249 13.475 14.3083 12.1333C12.0249 10.6083 8.2666 10.6083 5.9666 12.1333Z'
        stroke='#0D1333'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
